import {createSvgIcon} from "@mui/material";

const ChevronDownIcon = createSvgIcon(
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
    <path d="M15 7.5L10 12.5L5 7.5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>,
  'ChevronDown',
)

export default ChevronDownIcon
